/* Reconstructed from tenant.zip:public/build/assets/utils-DEEYWRUN.js
 * Original SHA-256: 379c7c0833d3c0bb751f3fcec1f5c5ebe05ebd7d2149fe6f9a64113e455f84b5
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
function e(t) {
  let n, r, i;
  if (typeof t != `object` || !t) return t;
  for (i in ((n = Array.isArray(t) ? [] : {}), t)) ((r = t[i]), (n[i] = e(r)));
  return n;
}
export { e as t };
